import React, { useState } from 'react';
import axios from '../utils/api';
import { useNavigate } from 'react-router-dom';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post('/auth/forgot-password/', { email });
      setMessage('Reset link sent to your email.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError('Error sending reset link.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <i className="fas fa-lock"></i>
          </div>
          <h1 className="auth-title">Forgot Password?</h1>
          <p className="auth-subtitle">Enter your email and we'll send you a reset link</p>
        </div>

        {message && (
          <div className="alert alert-success">
            <i className="fas fa-check-circle"></i>
            {message}
          </div>
        )}

        {error && (
          <div className="alert alert-error">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleReset} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-wrapper">
              <i className="fas fa-envelope input-icon"></i>
              <input
                type="email"
                id="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block" 
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>
                Sending reset link...
              </>
            ) : (
              <>
                <span>Send Reset Link</span>
                <i className="fas fa-paper-plane"></i>
              </>
            )}
          </button>

          <div className="auth-divider">
            <span>Remember your password?</span>
          </div>

          <button 
            type="button" 
            className="btn btn-outline-primary btn-block"
            onClick={() => navigate('/login')}
          >
            <i className="fas fa-arrow-left"></i>
            Back to Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
